'use client';
import { useEffect, useMemo, useState } from 'react';
import { ONE_MINUTE } from '@/helpers/dateTime';
import { useGetCommonStore } from '@/store';
import { getSpinsLeftAmount } from '../helpers/fortuneWheel';

export const ROLLS_PER_DAY = 5;

export const useDiceRoll = () => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const diceLootboxes = useCommonStore.use.diceLootboxes();

  const [rollsLeftAmount, setSpinsLeftAmount] = useState(
    getSpinsLeftAmount(diceLootboxes, ROLLS_PER_DAY)
  );

  useEffect(() => {
    if (!isAuthenticated) return;

    setSpinsLeftAmount(getSpinsLeftAmount(diceLootboxes, ROLLS_PER_DAY));

    const interval = setInterval(() => {
      setSpinsLeftAmount(getSpinsLeftAmount(diceLootboxes, ROLLS_PER_DAY));
    }, ONE_MINUTE);

    return () => clearInterval(interval);
  }, [diceLootboxes, isAuthenticated]);

  const isDailyRollsLimit = useMemo(
    () => isAuthenticated && rollsLeftAmount <= 0,
    [rollsLeftAmount, isAuthenticated]
  );

  return {
    rollsLeftAmount,
    isDailyRollsLimit,
  };
};
